import css from 'styled-jsx/css';

const styles = css.global`#mao-na-roda-banner.stacked-banner {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  position: relative;
  z-index: 9;
}

#mao-na-roda-banner .bg-image-wrapper {
  height: calc(100vh - 300px);
  max-height: 454px;
  min-height: 270px;
}

#mao-na-roda-banner .bg-image-wrapper picture {
  display: flex;
  width: 100%;
  height: 100%;
}

#mao-na-roda-banner .bg-image-wrapper picture img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
#mao-na-roda-banner .fade-banner {
  opacity: 0.25;
  background: var(--Red-Red-Boston-01, #C00);
  position: absolute;
  width: 100%;
  height: calc(100vh - 300px);
  max-height: 454px;
  min-height: 270px;
}
#mao-na-roda-banner .fade-banner-gradiente {
  background: linear-gradient(90deg, #900 0%, rgba(153, 0, 0, 0.73) 10.94%, rgba(153, 0, 0, 0.00) 56.77%);
  width: 100%;
  height: calc(100vh - 300px);
  max-height: 454px;
  min-height: 270px;
  position: absolute;
}

#mao-na-roda-banner .santander-symbol {
  background-image: url(assets/c2c/banners/santander-symbol.svg);
  width: 100%;
  height: calc(100vh - 300px);
  max-height: 454px;
  min-height: 270px;
  position: absolute;
  left: -90px;
  background-repeat: no-repeat;
  background-size: contain;
}

#mao-na-roda-banner .text-box-position {
  margin-top: -200px;
  position: relative;
}

#mao-na-roda-banner .text-box {
  background: #990000;
  width: 100%;
  max-width: 849px;
  padding: 24px 16px 40px 16px;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
}

#mao-na-roda-banner .text-box .main-text {
  font-family: 'SantanderHeadline';
  font-size: 40px;
  font-weight: 400;
  line-height: 60px;
  text-align: left;
  color: #fff;
}

#mao-na-roda-banner .text-box .alt-text {
  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: left;
  color: #fff;
  max-width: 600px;
}

#mao-na-roda-banner .text-box .btn-simulate {
  box-sizing: border-box;
  height: 48px;
  width: 200px;
}


@media (min-width: 992px) {
  #mao-na-roda-banner.stacked-banner {
    padding-bottom: 8px!important;
  }


  #mao-na-roda-banner .text-box {
    padding: 24px 16px 49px 47px;
    gap: 0;
  }

  #mao-na-roda-banner .text-box .alt-text {
    height: 112px;
  }

  #mao-na-roda-banner .santander-symbol {
    left: 0;
    width: 537px;
    height: calc(100vh - 180px);
    max-height: 436px;
    min-height: 300px;
  }

  #mao-na-roda-banner .bg-image-wrapper,
  #mao-na-roda-banner .fade-banner,
  #mao-na-roda-banner .fade-banner-gradiente {
    height: calc(100vh - 180px);
    max-height: 436px;
    min-height: 300px;
  }
}
@media (min-width: 1200px) {
  #mao-na-roda-banner .bg-image-wrapper picture img {
    object-position: 0 40%;
  }
}

@media (min-width: 1600px) {
  #mao-na-roda-banner .bg-image-wrapper picture img {
    object-position: 0 40%;
  }
}

@media (min-width: 1900px) {
  #mao-na-roda-banner .bg-image-wrapper picture img {
    object-position: 0 39%;
  }
}
`;

export default styles;